import PageHead from './PageHead';

export { PageHead };
export default PageHead;
